const _excluded = ["active", "children", "parentBindings", "viewSpy", "spyCallback"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// @ts-strict-ignore
import * as React from 'react';
import { ScrollElement, scroller, scrollSpy } from 'react-scroll';
import { useMountEffect } from 'common/onboarding/utils';
const SCROLL_CONTAINER_ID = "scrollable";
export { scrollSpy };
export const scrollToStep = function scrollToStep(step) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    skipAnimation: false
  };
  const {
    skipAnimation
  } = options;
  scroller.scrollTo(step, {
    duration: 1000,
    delay: 0,
    offset: 0,
    smooth: skipAnimation ? false : "easeInOutQuart",
    containerId: SCROLL_CONTAINER_ID
  });
};
export const Scrollable = React.forwardRef((props: {
  children;
  className;
}, ref: React.MutableRefObject<HTMLDivElement>) => {
  return <div className={props.className} id={SCROLL_CONTAINER_ID} ref={ref}>
        {props.children}
      </div>;
});
const Element = props => {
  const {
      active,
      children,
      parentBindings,
      viewSpy,
      spyCallback
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [isInView, setIsInView] = React.useState(false);
  const observerRef = React.useRef(null);
  const elementRef = React.useRef(null);
  useMountEffect(() => {
    if (viewSpy) {
      observerRef.current = new IntersectionObserver(_ref => {
        let [entry] = _ref;
        if (entry.isIntersecting && elementRef.current) {
          setIsInView(true);
          observerRef.current.unobserve(elementRef.current);
        }
      }, {
        root: document.querySelector("#".concat(SCROLL_CONTAINER_ID)),
        rootMargin: "-50% 0% -50% 0%"
      });
    }
  });
  React.useEffect(() => {
    var _observerRef$current;
    (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.observe(elementRef.current);
    return () => {
      var _observerRef$current2;
      (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
    };
  }, [observerRef.current]);
  React.useEffect(() => {
    if (viewSpy && spyCallback && isInView) {
      spyCallback();
    }
  }, [isInView, viewSpy, spyCallback]);
  const asActive = viewSpy && isInView || active;
  return <div {...rest} style={{
    opacity: asActive ? 1 : 0.2,
    pointerEvents: !asActive && "none"
  }} ref={elementRef} data-sentry-component="Element" data-sentry-source-file="scroll-manager.tsx">
      {children}
    </div>;
};
export const ScrollableElement = ScrollElement(Element);